import { Action } from 'redux';
import { OnExchangeEnrollPersonI } from '../interfaces/on-exchange-enroll.person.interface';

export interface OnExchangePersonStateStructure {
  persons: OnExchangeEnrollPersonI[];
}
const INITIAL_STATE: OnExchangePersonStateStructure = {
  persons: []
};

const RESET_ON_EXCHANGE_APPLICATION_PERSONS = 'RESET_ON_EXCHANGE_APPLICATION_PERSONS';
const ADD_ON_EXCHANGE_APPLICANT_PERSON = 'ADD_ON_EXCHANGE_APPLICANT_PERSON';

export class OnExchangePersonAction implements Action {
  type: string;
  person?: OnExchangeEnrollPersonI;
}

export function addOnExchangeApplicationPerson(person: OnExchangeEnrollPersonI): OnExchangePersonAction {
  return { type: ADD_ON_EXCHANGE_APPLICANT_PERSON, person };
}
export function resetOnExchangeApplicationPersons(): OnExchangePersonAction {
  return { type: RESET_ON_EXCHANGE_APPLICATION_PERSONS };
}

export const ON_EXCHANGE_PERSON_REDUCER_NAME = 'OnExchangePerson';
export function OnExchangePerson(
  state: OnExchangePersonStateStructure = INITIAL_STATE,
  action: OnExchangePersonAction
) {
  const copiedState: OnExchangePersonStateStructure = JSON.parse(JSON.stringify(Object.assign({}, state)));

  switch (action.type) {

    case ADD_ON_EXCHANGE_APPLICANT_PERSON:

      copiedState.persons.push(action.person);
      copiedState.persons[copiedState.persons.length - 1].id = Math.random();
      return Object.assign({}, state, copiedState);

    case RESET_ON_EXCHANGE_APPLICATION_PERSONS:
      return Object.assign({}, state, INITIAL_STATE);
    default:
      return state;
  }
}
